import { ImageTransform } from './image'
import { Section } from './section'

export interface Teaser {
  id: number
  name: string
  active_from: string
  active_to: string
  priority: number
  project_id: number
  active: boolean
  section_ids: number[]
  clicks: number
  views: number
  items: TeaserItem[]
  sections: Section[]
  hide_image: number | null
  status: number
}

export enum TeaserPriority {
  MIN = 0,
  MEDIUM = 1,
  MAX = 2,
}

export interface TeaserItem {
  id: number
  item_id: number
  model: string
  model_id: number
  name: string
  project_id: number
  sort: number
  teaser_id: number
  url: string | null
  image: ImageTransform | null
  image_id: number | null
  extra_fields: {
    sectionName: string
    advertising: number | null
    advertisingAge: number | null
    advertisingDomain: string | null
    advertisingGetField: string | null
    advertisingLegalInfo: string | null
    advertisingName: string | null
    advertisingOther: string | null
  } | null
  clicks?: number
}
